import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header pb-0",
  style: {"position":"relative"}
}
const _hoisted_5 = { class: "card-title d-flex align-items-start flex-column" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "card-label fw-bolder fs-4 mb-1" }, "Agendar serviço", -1)
const _hoisted_7 = { class: "text-muted mt-1 mb-1 fs-7 fw-light" }
const _hoisted_8 = {
  key: 0,
  class: "text-muted mt-1 fs-7 fw-light"
}
const _hoisted_9 = { class: "modal-body py-6 px-lg-10" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = {
  key: 0,
  class: "row",
  style: {"margin-bottom":"10px"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, "Serviços", -1)
const _hoisted_14 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_15 = {
  key: 1,
  class: "offset-md-4 mb-3"
}
const _hoisted_16 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 1,
  class: "row",
  style: {"margin-bottom":"10px"}
}
const _hoisted_20 = {
  key: 0,
  class: "fs-6 fw-bold mb-2 required"
}
const _hoisted_21 = {
  key: 1,
  clas: "d-flex"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, "Solicitação", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2" }, "Não possui solicitação", -1)
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_26 = {
  key: 1,
  class: "offset-md-4 mb-3"
}
const _hoisted_27 = {
  key: 2,
  class: "row"
}
const _hoisted_28 = { class: "col-6" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold required mb-2" }, "Cliente", -1)
const _hoisted_30 = { class: "col-6" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold required mb-2" }, "Placa", -1)
const _hoisted_32 = { class: "fv-row mb-4" }
const _hoisted_33 = { class: "col" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, " Horário recepção ", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_36 = {
  key: 3,
  class: "fv-row mb-4"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, "Detalhes", -1)
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, "Tipo de tarefa", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_42 = { class: "col" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, "Técnico responsável", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col-12" }
const _hoisted_47 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_49 = {
  key: 0,
  class: "col-12"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, "Data Final da tarefa", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_52 = { class: "row" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, " Horário inicial ", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, " Horário final ", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_57 = {
  key: 0,
  class: "col-6"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, " Horário Entrega Combinada ", -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_60 = { class: "modal-footer flex-end px-lg-10" }
const _hoisted_61 = ["data-kt-indicator"]
const _hoisted_62 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_63 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_64 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_time_select = _resolveComponent("el-time-select")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade show",
    id: `kt_modal_add_event_${_ctx.id}`,
    "aria-modal": "true",
    role: "dialog",
    ref: "newTargetModalRef"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          class: "form fv-plugins-bootstrap5 fv-plugins-framework",
          id: "kt_modal_add_event_form",
          onSubmit: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.targetData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h3", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.targetData.cliente) + " - " + _toDisplayString(_ctx.targetData.placa ? _ctx.targetData.placa : _ctx.targetData.chassi) + " - Recepção: " + _toDisplayString(_ctx.targetData.taskDateTratada) + " " + _toDisplayString(_ctx.targetData.taskHourRecepcao), 1),
                (_ctx.targetData.consultorAgendadoTratado)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Consultor: " + _toDisplayString(_ctx.targetData.consultorAgendadoTratado), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                style: {"position":"absolute","right":"25px","top":"25px"},
                type: "button",
                class: "btn-close",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal())),
                "aria-label": "Close"
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("p", null, "Observações: " + _toDisplayString(_ctx.targetData.detalhes), 1)
                ])
              ]),
              (_ctx.initialForm?.osAberta)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _hoisted_13,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.servicosAgendado, (servico, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "col-md-6 mb-3"
                      }, [
                        (index % 2 === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                          : _createCommentVNode("", true),
                        (index % 2 === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(servico?.Descricao ? index + 1 + ` - ` : '') + " " + _toDisplayString(servico?.Descricao ?? ''), 1)
                      ]))
                    }), 128)),
                    (_ctx.servicosAgendadoLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.initialForm?.osAberta)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    (_ctx.solicitacao.length > 0)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_20, "Solicitação"))
                      : (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_24)),
                    (_ctx.solicitacao.length > 0)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.solicitacao, (servico, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "col-md-6 mb-3"
                          }, [
                            (index % 2 === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25))
                              : _createCommentVNode("", true),
                            (index % 2 === 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_26))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(index + 1) + " - " + _toDisplayString(servico), 1)
                          ]))
                        }), 128))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createVNode(_component_el_form_item, { prop: "eventName" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.targetData.cliente,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.targetData.cliente) = $event)),
                            type: "text",
                            disabled: true,
                            name: "eventName"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createVNode(_component_el_form_item, { prop: "taskPlaca" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.targetData.placa,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.targetData.placa) = $event)),
                            type: "text",
                            disabled: true,
                            name: "eventName"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_el_form_item, { prop: "taskHourRecepcao" }, {
                    default: _withCtx(() => [
                      _hoisted_34,
                      _createVNode(_component_el_time_select, {
                        modelValue: _ctx.targetData.taskHourRecepcao,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.targetData.taskHourRecepcao) = $event)),
                        start: _ctx.horarios.horaAbertura,
                        step: "00:15",
                        end: _ctx.horarios.horaFechamento,
                        placeholder: "Selecione o horário",
                        onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.verificaHorarioInicialRecepcao()))
                      }, null, 8, ["modelValue", "start", "end"]),
                      _hoisted_35
                    ]),
                    _: 1
                  })
                ])
              ]),
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _hoisted_37,
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.targetData.detalhes,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.targetData.detalhes) = $event)),
                      type: "textarea",
                      resize: "none",
                      rows: 2,
                      disabled: true,
                      name: "eventName"
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createVNode(_component_el_form_item, { prop: "taskType" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.targetData.taskType,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.targetData.taskType) = $event)),
                        "value-key": "TIPO",
                        filterable: "",
                        clearable: true,
                        placeholder: "Selecione",
                        "no-match-text": "Nenhum tipo foi encontrado",
                        "no-data-text": "Nenhum tipo foi encontrado"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tipoOptions, (tipo, i) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: i,
                              label: tipo.text,
                              value: tipo.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _hoisted_41
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _createVNode(_component_el_form_item, { prop: "tecnico" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.targetData.tecnico,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.targetData.tecnico) = $event)),
                        onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.desabilitaHorariosOcupados())),
                        "value-key": "TECNICO",
                        filterable: "",
                        clearable: true,
                        placeholder: "Selecione",
                        "no-match-text": "Nenhum técnico foi encontrado",
                        "no-data-text": "Nenhum técnico foi encontrado"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tecnicoOptions, (tipo, i) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: i,
                              label: tipo.text,
                              value: tipo.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _hoisted_44
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.usaChecklist == '147' ? 'Data inicial da tarefa' : 'Data da tarefa'), 1),
                  _createVNode(_component_el_form_item, { prop: "taskDate" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_config_provider, { locale: _ctx.ptBr }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.targetData.taskDate,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.targetData.taskDate) = $event)),
                            type: "text",
                            name: "eventStartDate",
                            format: "DD/MM/YYYY",
                            onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.verificaHorariosOcupados())),
                            clearable: false,
                            "disabled-date": _ctx.desabilitaDatasPassadas
                          }, null, 8, ["modelValue", "disabled-date"])
                        ]),
                        _: 1
                      }, 8, ["locale"]),
                      _hoisted_48
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.usaChecklist == '147')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      _hoisted_50,
                      _createVNode(_component_el_form_item, { prop: "taskDate" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_config_provider, { locale: _ctx.ptBr }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: _ctx.targetData.taskEndDate,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.targetData.taskEndDate) = $event)),
                                type: "text",
                                name: "eventStartDate",
                                format: "DD/MM/YYYY",
                                onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.verificaHorariosOcupados())),
                                clearable: false,
                                "disabled-date": _ctx.desabilitaDatasPassadas
                              }, null, 8, ["modelValue", "disabled-date"])
                            ]),
                            _: 1
                          }, 8, ["locale"]),
                          _hoisted_51
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.modeloName == 'HyundaiV1' ? 'col-3' : 'col-6')
                }, [
                  _createVNode(_component_el_form_item, { prop: "taskStartHour" }, {
                    default: _withCtx(() => [
                      _hoisted_53,
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.targetData.taskStartHour,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.targetData.taskStartHour) = $event)),
                        "value-key": "HORAINICIAL",
                        filterable: "",
                        clearable: false,
                        placeholder: "Horário inicial",
                        onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.desabilitaHorariosOcupados()))
                      }, {
                        empty: _withCtx(() => []),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.defaultInitialTimes, (time, i) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: i,
                              label: time.text,
                              value: time.value,
                              disabled: time.disabled
                            }, null, 8, ["label", "value", "disabled"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _hoisted_54
                    ]),
                    _: 1
                  })
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.modeloName == 'HyundaiV1' ? 'col-3' : 'col-6')
                }, [
                  _createVNode(_component_el_form_item, { prop: "taskEndHour" }, {
                    default: _withCtx(() => [
                      _hoisted_55,
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.targetData.taskEndHour,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.targetData.taskEndHour) = $event)),
                        "value-key": "HORAFINAL",
                        filterable: "",
                        clearable: false,
                        placeholder: "Horário final",
                        disabled: !_ctx.targetData.taskStartHour
                      }, {
                        empty: _withCtx(() => []),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.defaultFinalTimes, (time, i) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: i,
                              label: time.text,
                              value: time.value,
                              disabled: time.disabled
                            }, null, 8, ["label", "value", "disabled"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"]),
                      _hoisted_56
                    ]),
                    _: 1
                  })
                ], 2),
                (_ctx.modeloName == 'HyundaiV1')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                      _createVNode(_component_el_form_item, { prop: "taskHourEntrega" }, {
                        default: _withCtx(() => [
                          _hoisted_58,
                          _createVNode(_component_el_time_select, {
                            disabled: !_ctx.targetData.taskEndHour,
                            modelValue: _ctx.targetData.taskHourEntrega,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.targetData.taskHourEntrega) = $event)),
                            start: _ctx.targetData.taskEndHour,
                            step: "00:15",
                            end: _ctx.horarios.horaFechamento,
                            placeholder: "Horário entrega"
                          }, null, 8, ["disabled", "modelValue", "start", "end"]),
                          _hoisted_59
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("button", {
                "data-kt-indicator": _ctx.loading ? 'on' : null,
                class: _normalizeClass(["btn btn-sm btn-flex background_btn_1_opct text-white", {'disabled': _ctx.loading}]),
                type: "submit"
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_62, [
                      _createTextVNode(" Adicionar "),
                      _createElementVNode("span", _hoisted_63, [
                        _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_64, [
                      _createTextVNode(" Adicionando tarefa... "),
                      _hoisted_65
                    ]))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_61)
            ]),
            _hoisted_66
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 8, _hoisted_1))
}